import {
    HttpClient,
    HttpParams,
} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "src/environments/environment";
import {BaseRestService} from "./baseRestService"
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Accounts} from "../../classes/rest-classes/Accounts";
import {AccountAddress} from "../../authorise/models/accountaddress";
import {User} from "../../classes/user";
import CacheService from "../cacheService";

@Injectable({
    providedIn: 'root'
})
export class RestUsersService extends BaseRestService {
    private readonly BASE_URL: string;

    constructor(private http: HttpClient, private cacheService: CacheService) {
        super();
        this.BASE_URL = environment.restApiUrl + '/Users';
    }

    public checkUserLoggedIn(): Observable<boolean> {
        const url = `${this.BASE_URL}/Account`;
        return this.http.get<any>(url, {headers: this.authHeadersV2}).pipe(
            map(response => {
                return !!(response && response.firstName && response.lastName);
            })
        );
    }

    public logout(): Observable<boolean> {
        const url = `${this.BASE_URL}/Signout`;
        return this.http.post<{ success: boolean }>(url, {}, {headers: this.authHeadersV2, observe: 'response'})
            .pipe(
                map(response => {
                    if (response.status === 200) {
                        localStorage.clear();
                        return true;
                    }
                    return false;
                })
            );
    }

    public async getAccountDetails(): Promise<Accounts> {
        const url = `${this.BASE_URL}/Account`;
        const accountUserId = localStorage.getItem('userid');

        let item: Accounts | null = this.cacheService.getCacheItem<Accounts>(`account`);

        if (item?.accountUserId === Number(accountUserId)) {
            return item;
        }

        item = await this.http.get<Accounts>(url, {headers: this.authHeadersV2}).toPromise();

        return this.cacheService.addOrReplaceCacheItem(`account`, item);
    }

    public getAccountByUsername(accountId: number, username: string): Observable<User> {
        const url = `${this.BASE_URL}/AccountByUsername`;
        let queryParams = new HttpParams();
        queryParams = queryParams.append('accountId', accountId);
        queryParams = queryParams.append('username', username);
        return this.http.get<User>(url, {params: queryParams, headers: this.authHeadersV2}).pipe(map(res => <User>res));
    }

    public async getInceptionBackDate(): Promise<Accounts> {
        const url = `${this.BASE_URL}/Account`;
        let queryParams = new HttpParams();
        queryParams = queryParams.append('company', 3);

        let item = this.cacheService.getCacheItem<Accounts>(`account`);
        if (item) {
            return item;
        }

        item = await this.http.get<Accounts>(url, {params: queryParams, headers: this.authHeadersV2}).toPromise();
        return this.cacheService.addOrReplaceCacheItem(`account`, item);
    }

    getAccountFcaStatus(): Observable<boolean> {
        const url = `${this.BASE_URL}/IsAccountFcaCompliant`;
        return this.http.get<boolean>(url, {headers: this.authHeadersV2});
    }

    public getAccountAddress(): Observable<AccountAddress> {
        const url = `${this.BASE_URL}/AccountAddress`;
        return this.http.get<AccountAddress>(url, {headers: this.authHeadersV2});
    }

    getAccountUserDetails(userId: number): Observable<User> {
        const url = `${this.BASE_URL}/${userId}/AccountUserDetails`;
        return this.http.get<User>(url, {headers: this.authHeadersV2});
    }
}